import { call, put, takeEvery } from "redux-saga/effects"
import {
  createSession,
  connectToChat,
  connectToDialog,
  getMessages,
  subscribeToChat,
  deleteMessage,
  sendMessageWithAttachment,
} from "services/quickblox"
import { get, post, postImageAxios, postVideoAxios } from "helpers/api_helper"
import {
  deleteChatMessagesFailed,
  deleteChatMessagesSuccess,
  getChatUsers,
  getChatUsersFailed,
  getChatUsersSuccess,
  getCommentBoardFaield,
  getCommentBoardListFailed,
  getCommentBoardListSuccess,
  getCommentBoardSuccess,
  initChatSessionSuccess,
  loadChatMessagesFailed,
  loadChatMessagesSuccess,
  saveDialog,
  saveMessages,
  saveSession,
  sendMessageWithMediaFailed,
  sendMessageWithMediaSuccess,
  updateCommentBoardLayoutFailed,
  updateCommentBoardLayoutSuccess,
  uploadImagesFailed,
  uploadImagesSuccess,
  uploadVideosFailed,
  uploadVideosSuccess,
} from "./actions"
import {
  DELETE_CHAT_MESSAGES,
  GET_CHAT_USERS,
  GET_COMMENT_BOARD,
  GET_COMMENT_BOARD_LIST,
  INIT_CHAT_SESSION,
  LOAD_CHAT_MESSAGES,
  SEND_CHAT_NOTIFICATION,
  SEND_MESSAGE_WITH_MEDIA,
  UPDATE_COMMENT_BOARD_LAYOUT,
  UPLOAD_IMAGES,
  UPLOAD_VIDEOS,
} from "./actionTypes"
import { getFileBlob, getFormDataFromJSON, showToast } from "utils"

function* getCommentBoard({ payload: params }) {
  try {
    const response = yield get("/comment-board/menu-item", { params })
    yield put(getCommentBoardSuccess(response))
  } catch (error) {
    yield put(getCommentBoardFaield(error))
  }
}

function* updateCommentBoardLayout({ payload: params }) {
  try {
    const response = yield post("/comment-board/menu-item", params)
    yield put(updateCommentBoardLayoutSuccess(params))
    showToast("success", "Setup updated!", "Success")
  } catch (error) {
    yield put(updateCommentBoardLayoutFailed(error))
  }
}

function* getChatUsersSaga(params) {
  try {
    const response = yield post("/users", params)
    yield put(getChatUsersSuccess(response))
  } catch (error) {
    yield put(getChatUsersFailed(error))
  }
}

function* initChatSession({
  payload: {
    userId,
    login,
    password,
    dialogId,
    guestIds,
    onMessage = console.log,
    vendor_id,
    onSystemMessage = console.log,
  },
}) {
  try {
    let dialog_id = dialogId
    const session = yield createSession(login, password)
    yield put(saveSession(session))
    yield call(
      getChatUsersSaga,
      !guestIds
        ? { all: true, vendor_id }
        : { all: false, user_ids: guestIds, vendor_id }
    )
    yield connectToChat(session.user_id, password)
    if (!dialogId) {
      const response = yield post("/comment-board/rebuild-chat", {
        menu_item_id,
        vendor_id,
      })
      dialog_id = response?.dialog_id
    }
    const dialog = yield connectToDialog(dialog_id)
    yield put(saveDialog(dialog))
    const messages = yield getMessages(dialog, null)
    yield put(saveMessages(messages))
    subscribeToChat(onMessage, onSystemMessage)
    yield put(initChatSessionSuccess())
  } catch (error) {
    console.error(error)
  }
}

function* loadChatMessages({ payload: { dialog, beforeDateSent } }) {
  try {
    const messages = yield getMessages(dialog, beforeDateSent)
    yield put(loadChatMessagesSuccess(messages))
  } catch (error) {
    yield put(loadChatMessagesFailed(error))
  }
}

function* deleteChatMessages({ payload: params }) {
  try {
    deleteMessage(params)
    yield put(deleteChatMessagesSuccess(params.message_ids))
    showToast("success", "The messages have been deleted.")
  } catch (error) {
    showToast("erro", "Failed to delete messages. Please try again.")
    yield put(deleteChatMessagesFailed(error))
  }
}

// function* deleteChatMessages({ payload: params }) {
//   try {
//     for (let message of params.messageIds) {
//       deleteMessage(message)
//     }
//     // yield put(deleteChatMessagesSuccess(params.messageIds))
//   } catch (error) {
//     // yield put(deleteChatMessagesFailed(error))
//   }
// }

function* uploadImages({ payload: params }) {
  try {
    const response = yield postImageAxios(
      `/event/${params.eventId}/galleries`,
      getFormDataFromJSON(params.image)
    )
    yield put(uploadImagesSuccess(response))
  } catch (error) {
    yield put(uploadImagesFailed(error))
  }
}

function* uploadVideos({ payload: params }) {
  try {
    const response = yield postVideoAxios(
      `/event/${params.eventId}/galleries`,
      getFormDataFromJSON(params.video)
    )
    yield put(uploadVideosSuccess(response))
  } catch (error) {
    yield put(uploadVideosFailed(error))
  }
}

function* sendChatNotification({ payload: params }) {
  try {
    yield post("/chat-notifications/comment-board", params)
  } catch (error) {
    console.error(error)
  }
}

function* getCommentBoardList({ payload: params }) {
  try {
    const response = yield get("/menu-items", { params })
    yield put(getCommentBoardListSuccess(response))
  } catch (error) {
    yield put(getCommentBoardListFailed(error))
  }
}

function* sendMessageWithMedia({
  payload: {
    file,
    mediaType,
    media,
    message,
    userId,
    event_id,
    menu_item_id,
    vendor_id,
    xmpp_room_jid,
  },
}) {
  try {
    // if (mediaType === "image" && !!event_id) {
    //   yield postImageAxios(
    //     `/event/${event_id}/galleries`,
    //     getFormDataFromJSON({
    //       vendor_id: vendor_id,
    //       add_points: true,
    //       files: [getFileBlob(media)],
    //     })
    //   )
    // }
    // if (mediaType === "video" && !!event_id) {
    //   yield postVideoAxios(
    //     `/event/${event_id}/galleries`,
    //     getFormDataFromJSON({
    //       vendor_id: vendor_id,
    //       add_points: true,
    //       files: [getFileBlob(media)],
    //     })
    //   )
    // }
    yield call(sendMessageWithAttachment, xmpp_room_jid, file, message)
    yield post("/chat-notifications/comment-board", {
      sender_id: userId,
      event_id: event_id,
      vendor_id: vendor_id,
      menu_item_id: menu_item_id,
    })
    yield put(sendMessageWithMediaSuccess())
  } catch (error) {
    yield put(sendMessageWithMediaFailed(error))
    const errors = error?.message?.errors
    let message = "Please try again"
    if (typeof errors === "string") {
      message = errors
    } else if (typeof errors === "object") {
      message = Object.entries(errors)
        ?.map(([key, value]) => {
          const errorMessage = Array.isArray(value) ? value?.join(", ") : value
          return `${key}: ${errorMessage}`
        })
        .join("; ")
    }
    showToast("error", message, "Error")
  }
}

function* commentBoardSaga() {
  yield takeEvery(GET_COMMENT_BOARD, getCommentBoard)
  yield takeEvery(UPDATE_COMMENT_BOARD_LAYOUT, updateCommentBoardLayout)
  yield takeEvery(GET_CHAT_USERS, getChatUsersSaga)
  yield takeEvery(INIT_CHAT_SESSION, initChatSession)
  yield takeEvery(LOAD_CHAT_MESSAGES, loadChatMessages)
  yield takeEvery(DELETE_CHAT_MESSAGES, deleteChatMessages)
  yield takeEvery(UPLOAD_IMAGES, uploadImages)
  yield takeEvery(UPLOAD_VIDEOS, uploadVideos)
  yield takeEvery(SEND_CHAT_NOTIFICATION, sendChatNotification)
  yield takeEvery(GET_COMMENT_BOARD_LIST, getCommentBoardList)
  yield takeEvery(SEND_MESSAGE_WITH_MEDIA, sendMessageWithMedia)
}

export default commentBoardSaga
